<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

   
    <!-- home section -->
    <section class="video-bg-q home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="menu">
          <router-link to="/menu1">    <img 
                  src="../assets/images/menu.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 100px;"
                /></router-link>
              </div>
              <div class="menu-back">
                <a @click="playsound();$router.go(-1);">
<img
                  src="../assets/images/menu-back.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
</a>
              </div>
              <div class="menu-next">
                <router-link to="/menu1-active-learning">
                <img @click="playsound"
                  src="../assets/images/menu-next.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
                </router-link>
              </div>
        <div class="row justify-content-center">
        
            
          <div class="col-md-8">
          
            <div class="home-video">
              <h4 class="text-center">คำถามวิเคราะห์ประกอบวิดีโอตัวตนและความเป็นเจ้าของ</h4>
            
                <youtube video-id="1zPY-ntaDoM" ref="youtube" :player-vars="playerVars"   @playing="playing"></youtube>
               <!-- <div class="text-center"> <img @click="playVideo"
                  src="../assets/images/play-video.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 64px;"
                /></div> -->
            </div>
          </div>
        
        </div>
      </div>
    
    </section>
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import { audioPlayer, videoPlayer } from 'vue-md-player'
import 'vue-md-player/dist/vue-md-player.css'
export default {
  components: {
    audioPlayer,
    videoPlayer
  },
  data() {
    return {
      playerVars: {
        autoplay: 1
      },
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
      playerOptions: {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
         // poster: "/static/images/author.jpg",
        }
    };
  },
  mounted() {
   // this.loader();
  },
  computed: {
    player() {
        return this.$refs.videoPlayer.player
      }
  },
  
  methods: {
    async playVideo() {
      await this.player.playVideo()
      // Do something after the playVideo command
    },
    playsound(){
      var audio = new Audio('./click.mp3');
				audio.play();
    },
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
    onPlayerPlay(player) {
        // console.log('player play!', player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      // ...player event

      // or listen state event
      playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },

      // player is ready
      playerReadied(player) {
        console.log('the player is readied', player)
        // you can use it to do something...
        // player.[methods]
      }
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
